import { OctSpinnerComponent } from "@components/oct-spinner/oct-spinner.component";

import { CommonModule } from "@angular/common";
import { Component, computed, input } from "@angular/core";

import { OctSvgComponent } from "../oct-svg/oct-svg.component";

@Component({
  selector: "oct-button",
  imports: [CommonModule, OctSpinnerComponent, OctSvgComponent],
  styleUrls: ["./oct-button.component.scss"],
  template: `
    <button
      [attr.type]="htmlType()"
      [ngClass]="buttonClasses()"
      [disabled]="disabled() || loading()">
      <span class="button__content">
        <ng-container>
          @if (iconLeft()) {
            <oct-svg
              class="button__icon button__icon--left"
              [class.button__icon--flip-x]="iconFlip() === 'x'"
              [class.button__icon--flip-y]="iconFlip() === 'y'"
              [path]="'svgs/' + iconLeft() + '.svg'"
              [style.background-color]="disabled() ? null : iconColor()"
              [class.hidden]="loading()" />
          }
          @if (!iconOnly() && text()) {
            <span class="button__text" [class.hidden]="loading()">
              {{ text() }}
            </span>
          }
          @if (iconRight()) {
            <oct-svg
              class="button__icon button__icon--right"
              [class.button__icon--flip-x]="iconFlip() === 'x'"
              [class.button__icon--flip-y]="iconFlip() === 'y'"
              [path]="'svgs/' + iconRight() + '.svg'"
              [style.background-color]="disabled() ? null : iconColor()"
              [class.hidden]="loading()" />
          }
        </ng-container>
        @if (loading()) {
          <span class="button__spinner">
            <oct-spinner [size]="size()" />
          </span>
        }
      </span>
    </button>
  `,
})
export class OctButtonComponent {
  type = input<
    "primary" | "secondary" | "tertiary" | "link" | "chat" | "danger"
  >("primary");
  size = input<"sm" | "m" | "l" | "xl">("m");
  text = input<string>("");
  iconLeft = input<string>();
  iconRight = input<string>();
  iconOnly = input<boolean>(false);
  iconFlip = input<"x" | "y" | null>(null);
  loading = input<boolean>(false);
  disabled = input<boolean>(false);
  width = input<"full" | "auto">("auto");
  iconColor = input<string>("");
  htmlType = input<"button" | "submit" | "reset">("button");

  buttonClasses = computed(() => [
    "button",
    `button--${this.type()}`,
    `button--${this.size()}`,
    this.iconOnly() ? "button--icon-only" : "",
    this.disabled() ? "button--disabled" : "",
    this.loading() ? "button--loading" : "",
    this.width() === "full" ? "button--full-width" : "",
  ]);
}
